import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ef-sideNav__header" }
const _hoisted_2 = { class: "ef-sideNav__credentials" }
const _hoisted_3 = { class: "ef-sideNav__role" }
const _hoisted_4 = { class: "ef-sideNav__actions" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bell clickableW" }, null, -1)
const _hoisted_6 = { class: "ef-sideNav__notificationsCount" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user clickableW" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-question clickableW" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__separator" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__title" }, "Menu principal", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__separator" }, null, -1)
const _hoisted_12 = { class: "ef-sideNav__menu" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__itemText" }, "Accueil", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-users" })
], -1)
const _hoisted_16 = { class: "ef-sideNav__itemText" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Collaborateurs ")
const _hoisted_18 = {
  key: 1,
  class: "ef-sideNav__bubble -yellow"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-graduation-cap" })
], -1)
const _hoisted_20 = { class: "ef-sideNav__itemText" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Formations ")
const _hoisted_22 = {
  key: 1,
  class: "ef-sideNav__bubble -yellow"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-graduate" })
], -1)
const _hoisted_24 = { class: "ef-sideNav__itemText" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Parcours de formation ")
const _hoisted_26 = {
  key: 1,
  class: "ef-sideNav__bubble -yellow"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "ef-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-list-check" })
], -1)
const _hoisted_28 = { class: "ef-sideNav__itemText" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Inscriptions ")
const _hoisted_30 = {
  key: 1,
  class: "ef-sideNav__bubble -yellow"
}

import {onMounted, ref} from "vue";
import {randomColor} from '@/functions/utils.ts';
import {storeUser} from "@/stores/user";
import {storeSystem} from "@/stores/system";
import {storeToRefs} from "pinia";
import {useRouter} from 'vue-router';
import Loader from "@/components/Loader.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _storeSystem = storeSystem();
const {isModaleOpen, notifsCount, usersCount, trainingsCount, trainingPathsCount, subscriptionsCount, sideNavLoader } = storeToRefs(_storeSystem);
const _storeUser = storeUser();
const {user} = storeToRefs(_storeUser);

const router = useRouter();
const logout = () => {
  _storeUser.logout();
  router.push('login');
};

const loadInfos = () => {
  _storeSystem.getSidenavInfos();
}

onMounted(() => {
  loadInfos();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['ef-sideNav -open', { '-blur' : _unref(isModaleOpen) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "ef-sideNav__profileIcone",
        style: _normalizeStyle(`background-color: ${_unref(randomColor)(_unref(user).id)}`)
      }, _toDisplayString(_unref(user).firstname[0].toUpperCase()) + _toDisplayString(_unref(user).lastname[0].toUpperCase()), 5),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(user).role), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, { to: "/notifications" }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(notifsCount)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/profile" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/infos" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createElementVNode("i", {
          class: "fa-solid fa-right-from-bracket clickableW",
          onClick: logout
        })
      ])
    ]),
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        class: "ef-sideNav__navItem",
        to: "/home"
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _hoisted_14
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "ef-sideNav__navItem",
        to: "/users"
      }, {
        default: _withCtx(() => [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            (_unref(sideNavLoader))
              ? (_openBlock(), _createBlock(Loader, {
                  key: 0,
                  color: "white"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(usersCount)), 1))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "ef-sideNav__navItem",
        to: "/trainings"
      }, {
        default: _withCtx(() => [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            (_unref(sideNavLoader))
              ? (_openBlock(), _createBlock(Loader, {
                  key: 0,
                  color: "white"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(trainingsCount)), 1))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "ef-sideNav__navItem",
        to: "/trainingpaths"
      }, {
        default: _withCtx(() => [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            (_unref(sideNavLoader))
              ? (_openBlock(), _createBlock(Loader, {
                  key: 0,
                  color: "white"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(trainingPathsCount)), 1))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "ef-sideNav__navItem",
        to: "/subscriptions"
      }, {
        default: _withCtx(() => [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            (_unref(sideNavLoader))
              ? (_openBlock(), _createBlock(Loader, {
                  key: 0,
                  color: "white"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(subscriptionsCount)), 1))
          ])
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})